import { createStore } from "redux";
import reducer from "./reducers/reducers";
import { composeWithDevTools } from "redux-devtools-extension";

let store;

if (process.env.NODE_ENV === "development") {
  // Only use the Redux DevTools with custom hostname in development mode
  const composeEnhancers = composeWithDevTools({
    realtime: true,
    port: 8000,
    hostname: window.location.hostname, // Dynamically uses your current IP/Domain
  });
  store = createStore(reducer, composeEnhancers());
} else {
  // Standard store for production - No IP leakage
  store = createStore(reducer);
}

export default store;